import { render, staticRenderFns } from "./TransactionManagement.vue?vue&type=template&id=56196f48&"
import script from "./TransactionManagement.vue?vue&type=script&lang=js&"
export * from "./TransactionManagement.vue?vue&type=script&lang=js&"
import style0 from "./TransactionManagement.vue?vue&type=style&index=0&id=56196f48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports